import type { FormLoginTabsContent } from './FormLogin.types';
export const tabsContent: FormLoginTabsContent = {
  phone: ['auth.telephone', 'Telephone'],
  email: ['auth.email', 'E-mail']
};